// extracted by mini-css-extract-plugin
export default {"notification":"NotificationManager_notification__fCO1t","alert":"NotificationManager_alert__F40YO"};